import { parsePhoneNumber } from 'libphonenumber-js/max';

export const normalizePhoneNumber = (phoneNumber?: string | null): string => {
	if (!phoneNumber) return '';

	const trimmedPhone = phoneNumber.trim();
	if (!trimmedPhone) return '';

	try {
		return parsePhoneNumber(trimmedPhone).number;
	} catch {
		return trimmedPhone;
	}
};

export const isPhoneNumberValid = (phoneNumber?: string | null): boolean => {
	if (!phoneNumber) return false;

	try {
		return parsePhoneNumber(phoneNumber.trim()).isValid();
	} catch {
		return false;
	}
};
